import { render, staticRenderFns } from "./AllDonateSummary.vue?vue&type=template&id=238f32ff"
import script from "./AllDonateSummary.vue?vue&type=script&lang=js"
export * from "./AllDonateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports